export const isPointInArea = (x, y, area) => {
  if (!area.points || area.points.length < 3) return false;

  let inside = false;
  for (let i = 0, j = area.points.length - 1; i < area.points.length; j = i++) {
    if (
      area.points[i].y > y !== area.points[j].y > y &&
      x <
        ((area.points[j].x - area.points[i].x) * (y - area.points[i].y)) /
          (area.points[j].y - area.points[i].y) +
          area.points[i].x
    ) {
      inside = !inside;
    }
  }
  return inside;
};

export const isPointNearLine = (x, y, line, tolerance = 8) => {
  const checkPoints = line.points || [
    { x: line.startX, y: line.startY },
    { x: line.endX, y: line.endY },
  ];
  return checkPoints.some(
    (point) => Math.sqrt((x - point.x) ** 2 + (y - point.y) ** 2) <= tolerance
  );
};

export const isPointNearArrow = (x, y, arrow, tolerance = 8) => {
  const startDist = Math.sqrt(
    (x - arrow.startX) ** 2 + (y - arrow.startY) ** 2
  );
  const endDist = Math.sqrt((x - arrow.endX) ** 2 + (y - arrow.endY) ** 2);
  return startDist <= tolerance || endDist <= tolerance;
};

export const isPointInSquare = (x, y, square) => {
  return (
    x >= square.x &&
    x <= square.x + square.width &&
    y >= square.y &&
    y <= square.y + square.height
  );
};

export const isPointInCircle = (x, y, circle) => {
  const dist = Math.sqrt((x - circle.centerX) ** 2 + (y - circle.centerY) ** 2);
  return dist <= Math.max(circle.radiusX, circle.radiusY);
};

export const isPointInText = (x, y, text) => {
  const textWidth = text.text.length * (text.fontSize * 0.6);
  const textHeight = text.fontSize;
  
  return (
    x >= text.x &&
    x <= text.x + textWidth &&
    y >= text.y - textHeight &&
    y <= text.y
  );
};

export const findClickedElement = (x, y, elements, tolerance = 8) => {
  const { areas, lines, arrows, squares, circles, texts } = elements;

  for (const area of areas) {
    if (isPointInArea(x, y, area)) {
      return {
        element: area,
        type: 'area',
        color: area.fillColor,
        text: 'Alue',
        tool: 'area',
      };
    }
  }

  for (const line of lines) {
    if (isPointNearLine(x, y, line, tolerance)) {
      return {
        element: line,
        type: 'line',
        color: line.lineColor,
        text: 'Viiva',
        tool: 'line',
      };
    }
  }

  for (const arrow of arrows) {
    if (isPointNearArrow(x, y, arrow, tolerance)) {
      return {
        element: arrow,
        type: 'arrow',
        color: arrow.lineColor,
        text: 'Nuoli',
        tool: 'arrow',
      };
    }
  }

  for (const square of squares) {
    if (isPointInSquare(x, y, square)) {
      return {
        element: square,
        type: 'square',
        color: square.fillColor,
        text: 'Nelikulmio',
        tool: 'square',
      };
    }
  }

  for (const circle of circles) {
    if (isPointInCircle(x, y, circle)) {
      return {
        element: circle,
        type: 'circle',
        color: circle.fillColor,
        text: 'Ympyrä',
        tool: 'circle',
      };
    }
  }

  for (const textItem of texts || []) {
    if (isPointInText(x, y, textItem)) {
      return {
        element: textItem,
        type: 'text',
        color: textItem.textColor,
        text: 'Teksti',
        tool: 'text',
      };
    }
  }

  return null;
};
